import { css } from '@emotion/react';

const TOP_OFFSET = 87;

const backdrop = css({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 10,
});

const panel = css({
    position: 'absolute',
    bottom: 0,
    left: 8,
    right: 8,
    width: 'calc(100% - 16px)',
    maxHeight: `calc(100% - ${TOP_OFFSET}px)`,
    background: '#fff',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
});

export default { backdrop, panel };
